import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Snackbar, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Chip from '@mui/material/Chip';
import { useContext, useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { getPaymentCompliance } from "../../services/payments";
import { Alert, Grow } from "@mui/material";
import { Link } from 'react-router-dom';
import MessageContext from "../../context/MessageContext";

const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-container': {
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& .MuiDialog-paper': {
            margin: 0,
            borderRadius: 12,
            padding: theme.spacing(2),
            boxShadow: theme.shadows[5],
            backgroundColor: '#fff',
        },
        '& .MuiDialog-paperScrollPaper': {
            maxHeight: '90vh',
        }
    },
    dialogContent: {
        padding: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        fontSize: '1rem',
        color: '#333',
    },
    dialogTitle: {
        padding: theme.spacing(1),
        fontWeight: 600,
        fontSize: '1.25rem',
        color: '#222',
    },
    dialogActions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    }
}))

export default function CustomChip({ message }) {

    {/*Eliminar cuando quede modal original de downgrade*/ }
    const { removeMessage } = useContext(MessageContext);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const LOCALIZACIONES = 'LOCALIZACIONES';
    const NODOS = 'NODOS';
    const SUBCUENTAS = 'SUBCUENTAS';
    const REPORTES = 'REPORTES';
    const EMAILS = 'EMAILS';
    const MEDIDORES = 'MEDIDORES'
    const DOWNGRADE = "downgrade";
    const PENDING_PAYMENT = "pending_payment";
    const REMAINING_DAYS = "remaining_days";
    const classes = useStyles();
    {/*----------------------*/ }

    let history = useHistory();
    const [openDialog, setOpenDialog] = useState(false);
    const [validatingCompliance, setValidatingCompliance] = useState(false)
    const [complianceData, setComplianceData] = useState(null)
    const [isBlocked, setIsBlocked] = useState(false);

    {/*Eliminar cuando quede modal original de downgrade*/ }
    useEffect(() => {
        const fetchComplianceData = async () => {
            const res = await getPaymentCompliance();
            setComplianceData(res.data);
        };
        if (message.id === DOWNGRADE) {
            fetchComplianceData();
        }
    }, [message])

    {/*Eliminar cuando quede modal original de downgrade*/ }
    const handleClick = () => {
        switch (message.id) {
            case PENDING_PAYMENT:
                history.push('/pagos')
                break;
            case DOWNGRADE:
                setOpenDialog(true)
                break;
            case REMAINING_DAYS:
                history.push('/pagos?renew=true')
                break;
            default:
                break;
        }
    }
    {/*Eliminar cuando quede modal original de downgrade*/ }
    const getMaximumOfResource = (pendingKey) => {
        switch (pendingKey) {
            case LOCALIZACIONES:
                return complianceData.requisitos.max_locations
            case NODOS:
                return complianceData.requisitos.max_nodes
            case SUBCUENTAS:
                return complianceData.requisitos.max_invited_users
            case REPORTES:
                return complianceData.requisitos.max_reports_per_plan
            case EMAILS:
                return complianceData.requisitos.max_emails_clients
            case MEDIDORES:
                return complianceData.requisitos.max_meters
            default:
                return 0;
        }
    }

    const getLabelResource = (resource) => {
        return resource.toLowerCase()[0].toUpperCase() + resource.toLowerCase().slice(1)
    }

    const getUsageOfResource = (pendingKey) => {
        switch (pendingKey) {
            case LOCALIZACIONES:
                return complianceData.usage.localizaciones
            case NODOS:
                return complianceData.usage.nodos
            case SUBCUENTAS:
                return complianceData.usage.usuarios_invitados
            case MEDIDORES:
                return complianceData.usage.puntos_medicion
            default:
                return 0;
        }
    }

    const validateCompliance = async () => {
        setValidatingCompliance(true);
        setIsBlocked(true);
        const res = await getPaymentCompliance(true);
        setTimeout(() => {
            setValidatingCompliance(false);
            if (res.data.aceptacion_cambio_plan) {
                setSnackbar({ open: true, message: 'Cambio realizado correctamente', severity: 'success' });
                setOpenDialog(false);
            } else {
                setSnackbar({ open: true, message: 'Sigues sin cumplir con los requisitos para continuar', severity: 'error' });
            }
            setIsBlocked(false);
            removeMessage(DOWNGRADE);
        }, 10000);
    }

    return (
        <>
            <Box>
                <Chip
                    onClick={() => handleClick()}
                    color={message?.severity || "warning"}
                    icon={<WarningAmberIcon sx={{ color: "white" }} />}
                    label={message?.description}
                    sx={{
                        fontWeight: "bold",
                        borderRadius: "20px",
                        padding: "5px 10px",
                    }}
                />
            </Box>

            {/*Eliminar cuando quede modal original de downgrade*/}
            <Dialog open={openDialog} maxWidth="sm" fullWidth className={classes.dialog}>
                <DialogTitle className={classes.dialogTitle}>
                    {complianceData?.pendientes?.length > 0 ? <>Prestaciones excedidas</> : <>Suscripción vencida</>}
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    {complianceData?.pendientes?.length > 0 ? (
                        <>
                            <Typography variant="body1" gutterBottom>
                                Has excedido los límites de tu plan:
                            </Typography>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Recurso</b></TableCell>
                                        <TableCell><b>Uso actual</b></TableCell>
                                        <TableCell><b>Límite</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {complianceData?.pendientes?.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{getLabelResource(item)}</TableCell>
                                            <TableCell>{getUsageOfResource(item)}</TableCell>
                                            <TableCell>{getMaximumOfResource(item)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </>
                    ) :
                        <>
                            Tu suscripción actual venció, presiona <b>continuar</b> para pasar al plan <b>{complianceData?.proximo_plan}</b> o
                            presiona <Link to="/pagos" onClick={() => setOpenDialog(false)}>aquí</Link> para suscribirte a un nuevo plan.
                        </>}
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    {complianceData?.pendientes?.length > 0 ?
                        <Button color="primary" variant="contained" onClick={() => setOpenDialog(false)}>
                            Cerrar
                        </Button> :
                        (<>
                            {validatingCompliance ?
                                <CircularProgress />
                                :
                                <Button color="primary" variant="contained" onClick={validateCompliance}>
                                    Continuar
                                </Button>
                            }
                        </>)
                    }
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={2000}
                slots={{ transitions: Grow }}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert
                    severity={snackbar.severity}
                    variant="filled"
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {isBlocked && <Backdrop open={isBlocked} />}
        </>
    )
}
